var map = {
	"./music-instructions.json": 4694,
	"./music-library-intro2024.json": 4695,
	"./music-library-launch2024.json": 4696,
	"./music-progression.json": 4697,
	"./startSourcesAdvanced.json": 4698,
	"./startSourcesSimple.json": 4699,
	"./startSourcesSimple2.json": 4700,
	"./startSourcesTracks.json": 4701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4462;